import createApp from './app.js'

import authService from './service.auth.js'
import messagingService from './service.messaging.js'
import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyC35PkNTWeY5nkAsbGAemV-owxUeS_NkEU","authDomain":"gotit-b956e.firebaseapp.com","databaseURL":"https:\u002F\u002Fgotit-b956e.firebaseio.com","projectId":"gotit-b956e","storageBucket":"gotit-b956e.appspot.com","messagingSenderId":"16551778338","appId":"1:16551778338:web:5355bddc5a0579754c127b","measurementId":"G-Y9D1CP5K5X"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      messagingService(session, firebase, ctx, inject),
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    messaging,
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    messaging: messaging,
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}